function returnOptions(data, type) {
  // type-1是项目,2是产品
  // 这里注意，一定要把对象中的属性命名为name和value，这样可以覆盖series中的属性，使用我们自己的数据
  const newItemSaleRankList = [];
  if (type == 1) {
    data.map((item) => {
      const Object = {
        value: item.salePercentage,
        name: item.itemName,
        saleCount: item.saleCount,
        salePercentage: item.salePercentage,
        itemName: item.itemName,
      };
      newItemSaleRankList.push(Object);
    });
  } else {
    data.map((item) => {
      const Object = {
        value: item.salePercentage,
        name: item.productName,
        saleCount: item.saleCount,
        salePercentage: item.salePercentage,
        itemName: item.productName,
      };
      newItemSaleRankList.push(Object);
    });
  }

  // 项目名称-用于legend
  const itemNameList = newItemSaleRankList.map((item) => item.itemName);
  // 这里判断有无值，设置无数据样式展示
  const showed = !data.length;
  return {
    title: {
      show: showed, // 是否显示title
      text: '暂无数据',
      left: 'center',
      top: 'center',
      textStyle: {
        color: '#909399',
        fontSize: 16,
        fontWeight: 400
      }
    },
    tooltip: {
      trigger: 'item',
      formatter(param) {
        return `${type == 1 ? '项目' : '产品'}销售量：${param.data.saleCount}<br/>占比：${param.data.salePercentage}%`;
      }
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      x: 'right', // 设置legend的左右位置
      y: 'top', // 设置legend的上下位置
      data: itemNameList,
      // 当echarts的legend字数超过15个字符时，变成省略
      formatter(name) {
        return (name.length > 15 ? (`${name.slice(0, 15)}...`) : name);
      }
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: '80%',
        // center: '70%',
        center: ['45%', '43%'],
        data: newItemSaleRankList,
        // 去掉提示线
        label: {
          normal: {
            position: 'inner',
            show: false
          }
        },
        labelLine: {
          show: false
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };
}
export const echartsC = returnOptions;
